<template>
  <div class="login-form-wrapper">
    <div class="arrow-container-3">
      <a @click="goToBack">
        <img src="@/assets/timeslot-images/left-arrow.svg" />
      </a>
    </div>
    <div
      class="text-block-4"
      style="font-family: 'Galano grotesque-Medium', sans-serif; margin-top: 30px;"
    >
      Already have an account?
      <router-link to="/login" class="link">Login</router-link>
    </div>
    <div class="div-block signup">
      <div class="text-block">Welcome to Timeslate 👋</div>
      <div
        class="text-block-3"
        style="font-family: 'Galano grotesque-Medium', sans-serif;"
      >
        Create an account to start using Timeslate today!
      </div>
    </div>
    <div class="div-block">
      <div id="g-btn">
        <!--                  <div><img src="@/assets/img/google-icon.svg" /></div>-->
        <!--                  <div class="google-text">Continue with Google</div>-->
      </div>
      <div class="divider-container">
        <img src="@/assets/timeslot-images/or-divider.svg" width="100%" />
      </div>
      <FormulateForm>
        <div class="register">
          <div class="name-width">
            <FormulateInput
              type="text"
              placeholder="First name"
              validation="required"
              name="firstName"
              validation-name="First name"
              v-model="initiateModel.firstName"
            />
          </div>
          <div class="name-width">
            <FormulateInput
              type="text"
              name="lastName"
              placeholder="Last name"
              validation="required"
              validation-name="Last name"
              v-model="initiateModel.lastName"
            />
          </div>
        </div>
        <FormulateInput
          type="email"
          name="email"
          placeholder="Email address"
          validation="required"
          validation-name="Email address"
          v-model="initiateModel.email"
        />
        <FormulateInput
          type="select"
          validation="required"
          name="country"
          validation-name="Country"
          placeholder="Country"
          :options="countries"
          v-model="initiateModel.country"
        />

        <!--        <div class="phone-number-code">-->
        <!--          <div class="code">-->
        <!--            <FormulateInput-->
        <!--              type="select"-->
        <!--              validation="required"-->
        <!--              name="countryCode"-->
        <!--              validation-name="Country code"-->
        <!--              placeholder="Country code"-->
        <!--              :options="codes"-->
        <!--              v-model="initiateModel.countryCode"-->
        <!--            />-->
        <!--          </div>-->
        <!--          <div class="phone-no">-->
        <!--            <FormulateInput-->
        <!--              type="text"-->
        <!--              validation="required"-->
        <!--              name="phone"-->
        <!--              placeholder="Phone number"-->
        <!--              validation-name="Phone number"-->
        <!--              v-model="initiateModel.phone"-->
        <!--            />-->
        <!--          </div>-->
        <!--        </div>-->

        <!--                <FormulateInput-->
        <!--                  type="password"-->
        <!--                  placeholder="Password"-->
        <!--                  validation="required"-->
        <!--                  validation-name="Password"-->
        <!--                />-->
        <!--                <FormulateInput-->
        <!--                  type="password"-->
        <!--                  validation="required|confirm"-->
        <!--                  placeholder="Confirm password"-->
        <!--                  validation-name="Password Confirmation"-->
        <!--                />-->

        <BaseComponentLoader
          v-if="loader.nonBlockingLoader && signUpActive"
          loaderAlignment="center"
        />
        <FormulateInput
          type="submit"
          label="Create Account"
          v-else
          @click="initiateEnrollment"
        />
      </FormulateForm>
    </div>
    <div
      class="text-block-2"
      style="font-family: 'Galano grotesque-Medium', sans-serif;"
    >
      © {{ currentYear() }} Timeslate
    </div>
  </div>
</template>

<script>
// import RouterUtils from "@/utils/BaseUtils/RouterUtils";
import AuthRequest from "@/model/requests/AuthRequest";
// import { countriesStates } from "@/utils/country/countriesStates";
import { countryCodes } from "@/utils/country/countryCodes";
import StoreUtils from "@/utils/BaseUtils/StoreUtils";
import BaseComponentLoader from "@/components/BaseComponents/BaseComponentLoader";
import { mapState } from "vuex";
import jwt_decode from "jwt-decode";
import RouterUtils from "@/utils/BaseUtils/RouterUtils";

export default {
  name: "TimeslotSignUpForm",
  components: { BaseComponentLoader },
  data() {
    return {
      initiateModel: AuthRequest.initiateEnrollment,
      googleModel: AuthRequest.googleSignUp,
      loginModel: AuthRequest.login,
      signUpActive: false
    };
  },
  computed: {
    countries() {
      return countryCodes.map(data => {
        return { label: data.name, value: data.name };
      });
    },
    codes() {
      // return countryCodes.map(data => `${data.name}: ${data.dial_code}`);
      return countryCodes.map(data => {
        return {
          label: `${data.name}:${data.dial_code}`,
          value: data.dial_code,
          id: data.code
        };
      });
    },
    ...mapState(["loader"]),
    ...mapState({
      userCountryCode: state => state.auth.userCountryCode,
      userPhoneNo: state => state.auth.userPhoneNo
    })
  },
  methods: {
    initiateEnrollment() {
      this.initiateModel.countryCode = this.userCountryCode;
      this.initiateModel.phone = this.userPhoneNo;
      StoreUtils.dispatch(
        StoreUtils.actions.auth.START_ENROLLMENT,
        this.initiateModel
      ).then(() => {
        this.signUpActive = true;
      });
      StoreUtils.commit("auth/setEmail", this.initiateModel.email);
      StoreUtils.commit("auth/setCountryCode", this.initiateModel.countryCode);
    },
    currentYear() {
      let current_date = new Date();
      let current_year = current_date.getFullYear();
      return current_year;
    },
    handleCredentialResponse(response) {
      let responsePayload = jwt_decode(response.credential);
      if (Object.keys(response).length > 0) {
        this.googleModel.idToken = response.credential;
        this.googleModel.countryCode = this.userCountryCode;
        this.googleModel.phone = this.userPhoneNo;
        StoreUtils.dispatch("auth/googleEnrollment", this.googleModel).then(
          () => {
            this.loginModel.username = responsePayload.email;
            this.loginModel.password = "000000";
            this.loginModel.idToken = response.credential;
            StoreUtils.dispatch("auth/timeslotLogin", this.loginModel);
          }
        );
      }
    },
    goToBack() {
      RouterUtils.goBackOnce();
    }
  },
  mounted() {
    // this.handleCredentialResponse();
    google.accounts.id.initialize({
      client_id:
        "394220425794-jd16sm6enp7594crf6d1g41bes0tco28.apps.googleusercontent.com",
      callback: this.handleCredentialResponse
    });
    window.google.accounts.id.renderButton(document.getElementById("g-btn"), {
      type: "standard",
      shape: "rectangular",
      theme: "outline",
      size: "large",
      custom_width: "800",
      logo_alignment: "center",
      text: "signup_with"
    });
    google.accounts.id.prompt();
  }
};
</script>

<style scoped>
.register {
  display: flex;
  justify-content: space-between;
}
.name-width {
  width: 47%;
}

.phone-number-code {
  display: flex;
  justify-content: space-between;
  width: 100%;
  /*gap: 5px;*/
}
.code {
  width: 47%;
}
.phone-no {
  width: 47%;
}
.divider-container {
  margin: 20px 0;
}
</style>
